<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
                Understanding Your Stewardship Structure
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">
                Stewardship is the process of acknowledging, thanking, and keeping donors engaged after they've made a gift. Maintaining strong relationships with current donors is essential to building a sustainable and growing donor pipeline. This section helps you design a structured approach to donor stewardship, including personalized recognition and meaningful benefits.
            </p>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">
                You'll map out a donor recognition and benefit structure that matches the scale of giving—offering accessible, high-impact touches for small donors and deeper engagement for major givers. Examples may include newsletters, annual reports, special events, field visits, or naming opportunities. By creating a thoughtful stewardship structure, you ensure donors feel appreciated, valued, and invested in your organization's long-term success.
            </p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation';
// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 